// Module
var code = "<div class=\"panel-heading\"> <h1>FX Wire Entitlements</h1> <div class=\"inline-grouping inline-grouping-right\"></div> </div> <div ng-init=\"productType = 'WireTransferDLI'\"> <div ng-controller=\"WireTransfersEntitlementsController\" ng-include=\"'app/admin/users/views/wireTransferEntitlementsForm.html'\"></div> </div> ";
// Exports
module.exports = code;